// src/openapi/utils.ts
import { fetchAuthSession } from '@aws-amplify/auth'
import { ProgressApi, Configuration, ChatApi, UserNoteApi } from '../../generated/api/aldebaran';
import { EntitlementsApi } from '../../generated/api/vega';
import {DefaultApi as Altair2Api, Configuration as Altair2Config} from '../../generated/api/altair2';
import {Configuration as VegaConfig} from '../../generated/api/vega';
import {DefaultApi as CanopusApi, Configuration as CanopusConfig} from '../../generated/api/canopus';
// import { ChatApi, Configuration, EntitlementsApi, ProgressApi, UserNoteApi } from 

/**
 * Builds a fully‐authenticated ProgressApi client,
 * using the Cognito ID Token from fetchAuthSession().
 */
export async function getProgressApi(): Promise<ProgressApi> {
  const token = await getIdToken();
  const config = new Configuration({
    basePath: 'https://aldebaran.api.weapps.net',
    headers: { Authorization: `Bearer ${token}` },
    // accessToken: token,       // sends Authorization: Bearer <id-token>
  })


// console.log('Using Progress API with token:', token)
  // console.log('Config', config)
  return new ProgressApi(config)
}

/**
 * Builds a fully‐authenticated ProgressApi client,
 * using the Cognito ID Token from fetchAuthSession().
 */
export async function getChatApi(): Promise<ChatApi> {
  const token = await getIdToken();
  const config = new Configuration({
    basePath: 'https://aldebaran.api.weapps.net',
    headers: { Authorization: `Bearer ${token}` },
    // accessToken: token,       // sends Authorization: Bearer <id-token>
  })
// console.log('Using Progress API with token:', token)
  // console.log('Config', config)
  return new ChatApi(config)
}


export async function getUserNoteApi(): Promise<UserNoteApi> {
  const token = await getIdToken();
  const config = new Configuration({
    basePath: 'https://aldebaran.api.weapps.net',
    headers: { Authorization: `Bearer ${token}` },
    // accessToken: token,       // sends Authorization: Bearer <id-token>
  })
// console.log('Using Progress API with token:', token)
  // console.log('Config', config)
  return new UserNoteApi(config)
}

export async function getEntitlementsApi(): Promise<EntitlementsApi> {
  const token = await getIdToken();

    const vegaConfig = new VegaConfig({
    basePath: 'https://vega.api.weapps.net',
    headers: { Authorization: `Bearer ${token}` },
    // accessToken: token,       // sends Authorization: Bearer <id-token>
  });
  return new EntitlementsApi(vegaConfig);
}


export async function getAltair2Api(authenticated:boolean): Promise<Altair2Api> {
  if(authenticated){
    const token = await getIdToken();

      const config = new Altair2Config({
      basePath: 'https://altair2.api.weapps.net',
      headers: { Authorization: `Bearer ${token}` },
      // accessToken: token,       // sends Authorization: Bearer <id-token>
    });
    return new Altair2Api(config);
  } else {
    const config = new Altair2Config({
      basePath: 'https://altair2.api.weapps.net'
    });
    return new Altair2Api(config);
  }
}

export async function getCanopusAPI(p:{authenticated:boolean}): Promise<CanopusApi> {
  if(p.authenticated){
    const token = await getIdToken();
      const config = new CanopusConfig({
      basePath: 'https:/canopus.api.weapps.net',
      headers: { Authorization: `Bearer ${token}` },
      // accessToken: token,       // sends Authorization: Bearer <id-token>
    });
    return new CanopusApi(config);
  } else {
    const config = new CanopusConfig({
      basePath: 'https://canopus.api.weapps.net'
    });
    return new CanopusApi(config);
  }
}


/**
 * Grab Cognito ID Token via fetchAuthSession()
 */
async function getIdToken(): Promise<string> {
  const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString() || '';
}

/**
 * Helper to wrap calls and log failures.
 */
export async function safeApiCall<T>(
  context: string,
  fn: () => Promise<T>
): Promise<T | null> {
  try {
    return await fn()
  } catch (error) {
    console.error(`[API ERROR] ${context}`, error)
    return null
  }
}
